
























































/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaWebsiteForm from "@/Ui-Components/Domain/ParticaWebsiteForm.vue";
import { CustomerUrlModel, CustomerUrlModelSecurityType, CustomerAuthConfigModel, ICustomerAuthConfigModel, CustomAuthConfigDTO, ICustomAuthConfigDTO, CustomerUrlModelSecure, ICustomerUrlModel, SecurityType, Auth0CreateDetails, AuthViewerConfigDTO } from "../../Generated/ParticaAPI";
import { DomainService, IDomainService } from "../../BusinessServices/domain";
import ParticaBaseView from "../Base/ParticaBaseView.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { getActionName, ParticaEvent, eParticaAction } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../Models/Buttons";
import ParticaWebsiteBase from "../Base/ParticaWebsiteBase.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import DomainSecurity from "@/Ui-Components/Domain/DomainSecurity.vue";
import Auth0Config from "@/Ui-Components/Domain/Auth0Config.vue";
import CustomAuthConfig from "@/Ui-Components/Domain/CustomAuth.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import Auth0Wizard from "../../Ui-Components/Domain/Auth0Wizard.vue";
import ParticaDialogCard from "@/Ui-Components/Common/Container/ParticaDialogCard.vue";
import AuthButtonConfig from "../../Ui-Components/Domain/AuthButtonConfig.vue";



@Component(
	{
		name: "ParticaWebsiteSecurity",
		components: {
			ParticaWebsiteForm,
			ParticaRowContainer,
			ParticaColumnContainer,
			ParticaCard,
			ParticaView,
			DomainSecurity,
			Auth0Config,
			CustomAuthConfig,
			ButtonList,
			Auth0Wizard,
			ParticaDialogCard,
			AuthButtonConfig
		}
	})
export default class ParticaWebsiteSecurity extends ParticaWebsiteBase {
	private data: ICustomerUrlModel | null = null;
	// create or inject services
	private domainService: IDomainService;
	@Prop() private id: number;
	private auth0config: ICustomerAuthConfigModel | null = null;
	private customConfig: ICustomAuthConfigDTO | null = null;
	private auth0wiz: Auth0CreateDetails = new Auth0CreateDetails();
	private showWizard: boolean = false;
	private viewerButtonConfig: AuthViewerConfigDTO = new AuthViewerConfigDTO();
	private showViewerButtons: boolean = false;

	private buttons: ButtonConfig[] = [
	];
	private viewerbuttons: ButtonConfig[] = [
		{ label: "Save Viewer Config", action: eParticaAction.WEBSITE_SAVE_AUTH_VIEWER_CONFIG, type: ButtonType.OK } as ButtonConfig,
	];
	private authbuttons: ButtonConfig[] = [
		{ label: "Create Auth0 Clients", action: eParticaAction.WEBSITE_AUTH0_WIZARD, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Viewer Authentication Links/Labels", action: eParticaAction.WEBSITE_AUTH_VIEWER_CONFIG, type: ButtonType.Normal } as ButtonConfig,
	];
	private secbuttons: ButtonConfig[] = [
		{ label: "Save Domain Security Settings", action: eParticaAction.WEBSITE_SAVE_CONFIG, type: ButtonType.OK } as ButtonConfig,
	];
	private apiconfigbuttons: ButtonConfig[] = [
		{ label: "View Client API Integration Settings", action: eParticaAction.WEBSITE_AUTH_CONFIG, type: ButtonType.OK, status: ButtonStatus.Enabled } as ButtonConfig
	];
	private wizardbuttons: ButtonConfig[] = [
		{ label: "Setup Auth0 Clients", action: eParticaAction.WEBSITE_AUTH0_CREATE, type: ButtonType.OK } as ButtonConfig
	];


	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.WEBSITE_SAVE_AUTH_VIEWER_CONFIG: {
					this.viewerButtonConfig = await this.domainService.saveViewerConfig(event.item as AuthViewerConfigDTO);
					this.showViewerButtons = false;
				}
				case eParticaAction.WEBSITE_AUTH_VIEWER_CONFIG: {
					this.showViewerButtons = true;
					break;
				}
				case eParticaAction.WEBSITE_AUTH0_WIZARD: {
					this.showWizard = true;
					break;
				}
				case eParticaAction.WEBSITE_AUTH_CONFIG: {
					this.navigate("authconfiguration", { id: this.id.toString() });
					break;
				}
				case eParticaAction.WEBSITE_AUTH0_CREATE: {
					this.auth0config = await this.domainService.createAuthClients(event.item as Auth0CreateDetails);
					this.showWizard = false;
					break;
				}
				case eParticaAction.WEBSITE_SAVE_CONFIG: {
					if (this.data !== null) {
						await this.domainService.updateSecurityType(this.id, this.data.securityType as CustomerUrlModelSecurityType);
						await this.domainService.saveAuthConfig(this.auth0config as ICustomerAuthConfigModel);
						switch (this.data.securityType) {
							case CustomerUrlModelSecurityType.TokenIntegration:
							case CustomerUrlModelSecurityType.Crm:
							case CustomerUrlModelSecurityType.CustomAPI: {
								await this.domainService.saveCustomAuthConfig(this.customConfig as ICustomAuthConfigDTO);
								break;
							}
						}
						await this.domainService.updateSecure(this.id, this.data.secure as CustomerUrlModelSecure);
						await this.init();
					}
					break;
				}
				default:
					{
						this.baseEventHandler(event);
					}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	private isCustom(): boolean {
		if (this.data === null) { return false; }

		switch (this.data.securityType) {
			case CustomerUrlModelSecurityType.TokenIntegration:
			case CustomerUrlModelSecurityType.Crm:
			case CustomerUrlModelSecurityType.CustomAPI: {
				this.SetButtonStatus(this.authbuttons, eParticaAction.WEBSITE_AUTH0_WIZARD, ButtonStatus.Disabled);
				return true;
				break;
			}
		}
		return false;
	}
	private isAuth0(): boolean {
		if (this.data === null) { return false; }
		switch (this.data.securityType) {
			case CustomerUrlModelSecurityType.CompulsoryRegistration:
			case CustomerUrlModelSecurityType.Subscription: {
				this.SetButtonStatus(this.authbuttons, eParticaAction.WEBSITE_AUTH0_WIZARD, ButtonStatus.Enabled);
				return true;
				break;
			}
		}
		return false;
	}

	@Watch("data.securityType")
	private async watchSecurityType(newValue: CustomerUrlModelSecurityType, oldValue: CustomerUrlModelSecurityType) {
		if (oldValue === undefined) { return; }
		if (this.data === null) { return; }
		if (this.auth0config === null) { return; }
		if (this.customConfig === null) { return; }
		switch (this.data.securityType) {
			case CustomerUrlModelSecurityType.TokenIntegration:
			case CustomerUrlModelSecurityType.Crm: {
				this.SetButtonStatus(this.apiconfigbuttons, eParticaAction.WEBSITE_AUTH_CONFIG, ButtonStatus.Disabled);
				if (this.customConfig.callbackUrl === null) {
					this.customConfig.secret = "";
					this.ShowSnackbar("Custom Authentication configuration not setup.");
				}
				this.$nextTick(() => {
					if (this.data !== null && this.auth0config !== null) {
						this.data.secure = CustomerUrlModelSecure.Register;
						this.auth0config.authProvider = 1; // custom								
					}
				});
				break;
			}
			case CustomerUrlModelSecurityType.CustomAPI: {
				if (this.customConfig.callbackUrl === null) {
					this.customConfig.secret = "";
					this.ShowSnackbar("Custom Authentication configuration not setup.");
				}
				this.$nextTick(() => {
					if (this.data !== null && this.auth0config !== null) {
						this.data.secure = CustomerUrlModelSecure.Register;
						this.auth0config.authProvider = 1; // custom
						this.SetButtonStatus(this.apiconfigbuttons, eParticaAction.WEBSITE_AUTH_CONFIG, ButtonStatus.Enabled);
					}
				});
				break;
			}
			case CustomerUrlModelSecurityType.CompulsoryRegistration: {
				if (this.auth0config.clientId === "") {
					this.auth0config.secret = "";
					this.auth0config.apiClientSecret = "";
					this.auth0config.scope = "email";
					this.ShowSnackbar("Auth0 configuration not setup.");
				}
				this.$nextTick(() => {
					if (this.data !== null && this.auth0config !== null) {
						this.auth0config.authProvider = 0; // auth0
						this.data.secure = CustomerUrlModelSecure.Register;
					}
				});
				break;
			}
			case CustomerUrlModelSecurityType.Subscription: {
				if (this.auth0config.clientId === "") {
					this.auth0config.secret = "";
					this.auth0config.apiClientSecret = "";
					this.auth0config.scope = "email";
					this.ShowSnackbar("Auth0 configuration not setup.");
				}
				this.$nextTick(() => {
					if (this.data !== null && this.auth0config !== null) {
						this.auth0config.authProvider = 0; // auth0
						this.data.secure = CustomerUrlModelSecure.Secure;
					}
				});
				break;
			}
			case CustomerUrlModelSecurityType.NoSecurity: {
				this.auth0config.authProvider = -1; // nothing
				this.data.secure = CustomerUrlModelSecure.Free;
				break;
			}
			case CustomerUrlModelSecurityType.Unknown: {
				this.ShowSnackbar("You cannot update the security type to unknown.");
				this.$nextTick(() => {
					if (this.data !== null) {
						this.data.securityType = CustomerUrlModelSecurityType.NoSecurity;
					}
				});
				break;
			}
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Home";
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.data = null;
			await this.getWebsiteNav(this.id);
			this.breadcrumbs.pop();
			this.domainService = this.particaServices.getDomainService();
			this.customConfig = await this.domainService.getCustomConfig(this.id);
			this.auth0config = await this.domainService.getAuth(this.id);
			this.data = await this.domainService.getWebsite(this.id);
			this.auth0wiz.customerUrlId = this.id;
			this.viewerButtonConfig = await this.domainService.loadViewerConfig(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
